"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CoreRouters;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Error = _interopRequireDefault(require("../errors/Error"));
var _newRoutes = _interopRequireDefault(require("./newRoutes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * API Main Core Router Component Holder
 * Sam Ayoub <melayyoub@svb.com> (svb.com)
 * Decsriptio: This is only a handler for other components
 * Here where we are checking minimum requirements of routers before running or importing other components
 * How to use? Readme.md
 */

// Mocking Needed
const MainMenu = "../mocking/main-menu.json";
function CoreRouters(props) {
  const router = (0, _react.useRef)(false);
  const {
    id,
    folderWId,
    folderWFolderWId,
    folderWFoldeWFolderWId,
    folderWFoldeWFolderWFolderWId,
    folderWFoldeWFolderWFolderWFolderWId,
    extra,
    folderWFoldeWFolderWFolderWFolderWFolderWId,
    homepage,
    newRouters
  } = props;
  //component loaded
  (0, _react.useEffect)(() => {
    // @todo: filtering requirements vs results
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:folder",
    element: id
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:folder/:id",
    element: folderWId
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:folder/:folderOne/:id",
    element: folderWFolderWId
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:folder/:folderOne/:folderTwo/:id",
    element: folderWFoldeWFolderWId
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:folder/:folderOne/:folderTwo/:folderThree/:id",
    element: folderWFoldeWFolderWFolderWId
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/",
    element: homepage
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:folder/:folderTwo/:folderThree/:folderFour/:id",
    element: folderWFoldeWFolderWFolderWFolderWId
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:folder/:folderTwo/:folderThree/:folderFour/:folderFive/:id",
    element: folderWFoldeWFolderWFolderWFolderWFolderWId
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:id",
    element: extra
  }), newRouters && (0, _newRoutes.default)(newRouters));
}